export default __webpack_public_path__ + "banner-framework-ab67a84c.png";